module.exports = __webpack_public_path__ + "img/vertical_6_7_8011.3cddded4.png";